<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from 'src/helpers/home_helpers';

	const updateHomeData = () => {
		save_home('premiumSceneConditionAdvertise', {
			seen: false,
		});

		home_data.set({
			...$home_data,
			premiumSceneConditionAdvertise: {
				seen: false,
			},
		});
	};
</script>

<IconButton class="mr-s" icon="fas fa-gem" on:click={updateHomeData}
	>Reset Premium Scene Condition Ads</IconButton
>
